import { render, staticRenderFns } from "./FeaturePopup.vue?vue&type=template&id=b1c1ca3c"
import script from "./FeaturePopup.vue?vue&type=script&lang=js"
export * from "./FeaturePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports